import CTAButton from "./CTAButton";

export default function Hero({ content = {}, productImage, onCheckout, canCheckout }) {
  const benefits = content.bullets || [];
  const title = content.title || "";
  const desc = content.desc || "";
  const badge = content.badge || "100% Alami • Pilihan Indonesia";
  const socialProof = content.social_proof || "4.9/5 dari 2.300+ pelanggan";
  const ctaText = content.cta_text || "Pesan Sekarang";

  return (
    <section className="relative overflow-hidden min-h-[100svh] flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${productImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-[oklch(0.38_0.18_25/0.8)] via-[oklch(0.52_0.22_25/0.6)] to-[oklch(1_0_0/0.3)]" />
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--kp-background)] via-[oklch(1_0_0/0.1)] to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-6xl px-5 py-20 grid lg:grid-cols-[1.2fr_1fr] gap-10 items-center">
        <div className="text-white animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur-md border border-white/30 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest">
            <span className="h-2 w-2 rounded-full bg-white animate-pulse" />
            {badge}
          </span>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-balance">
            {title}
          </h1>
          {desc && (
            <p className="mt-6 text-base sm:text-lg text-white/90 max-w-xl leading-relaxed">
              {desc}
            </p>
          )}

          {benefits.length > 0 && (
            <div className="mt-6 flex flex-wrap gap-2">
              {benefits.map((b, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur-md border border-white/25 px-3 py-1.5 text-xs sm:text-sm font-medium"
                >
                  <span className="text-green-300">✓</span> {b}
                </span>
              ))}
            </div>
          )}

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <CTAButton size="xl" pulse onClick={onCheckout} disabled={!canCheckout}>
              🔥 {ctaText}
            </CTAButton>
            <div className="flex items-center gap-3 text-sm text-white/90">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="h-9 w-9 rounded-full border-2 border-white bg-gradient-primary"
                  />
                ))}
              </div>
              <div>
                <div className="font-bold">⭐ {socialProof.split(" ")[0] || "4.9/5"}</div>
                <div className="text-xs opacity-90">{socialProof.split(" ").slice(1).join(" ") || "pelanggan puas"}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative hidden lg:block animate-float">
          <div className="absolute -inset-8 bg-white/10 backdrop-blur-xl rounded-[3rem] border border-white/20" />
          <img
            src={productImage}
            alt="Produk"
            className="relative rounded-[2.5rem] shadow-luxury w-full object-cover aspect-square"
          />
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 text-white/80 text-xs uppercase tracking-widest flex flex-col items-center gap-1">
        <span>Scroll</span>
        <span className="h-8 w-[1px] bg-white/60 animate-pulse" />
      </div>
    </section>
  );
}
